<div class="traffic-logs-sidebar">
    <div class="traffic-logs-sidebar__saved-search-section">
        <right-rail-vertical-expander
            icon="star"
            headerText="{{ l10nKeys.savedSearchesLabel | vtranslate }}"
        >
            <ng-container *ngrxLet="trafficLogsStore.savedSearches$ as savedSearches">
                <ng-container *ngFor="let saved of (savedSearches | transformSavedSearches); trackBy: trackByIndex">
                    <div
                        class="traffic-logs-sidebar__saved-search-section-entry"
                        (click)="addSavedSearchFilters(saved.search)"
                    >
                        <span class="traffic-logs-sidebar__saved-search-section-entry-text">{{ saved.name }}</span>
                        <cds-icon
                            shape="times"
                            size="16"
                            (click)="removeSavedSearch($event, saved.name)"
                        ></cds-icon>
                    </div>
                </ng-container>
            </ng-container>
        </right-rail-vertical-expander>
    </div>
    <div class="traffic-logs-sidebar__data-section">
        <ng-container *ngFor="let expanderConfig of expanderListConfig$ | async; trackBy: trackByIndex">
            <right-rail-vertical-expander
                *ngIf="!(expanderConfig.hidden ?? hidden) && (trafficLogsStore.listLogCount$ | async)"
                [icon]="expanderConfig.icon"
                [headerText]="expanderConfig.headerText"
            >
                <ng-container *ngFor="let child of expanderConfig.children; trackBy: trackByIndex">
                    <right-rail-expander-text-child
                        *ngIf="!(child.hidden ?? hidden)"
                        avi-tooltip
                        [positionsPriority]="signpostPositionPriorities"
                        [overlaySizeChange$]="trafficLogsSignpostStore.overlaySizeChange$"
                        [showOnClick]="true"
                        [tooltipControl$]="signpostCloseButtonControl$"
                        (onPositionChange)="handleSignpostConnectedPositionChange($event)"
                        (openedChange)="handleSignpostClosed($event)"
                        [text]="child.displayText"
                        [isActive]="(trafficLogsSignpostStore.selectedSignpost$ | async)?.configKey === child.configKey"
                    >
                        <ng-template #aviTooltipContent>
                            <signpost
                                [signpostPosition]="signpostPosition"
                                (onCloseButtonClick)="trafficLogsSignpostStore.closeSignpost()"
                            >
                                <logs-signpost
                                    [selectedSignpostConfig]="child"
                                    [poolId]="poolId"
                                ></logs-signpost>
                            </signpost>
                        </ng-template>
                    </right-rail-expander-text-child>
                </ng-container>
            </right-rail-vertical-expander>
        </ng-container>
    </div>
</div>
